import { commonLogin } from "@/lib/auth/api";
import { AUTH_EVENT_TYPE, authChannel } from "@/lib/auth/store";
import { localizeHref } from "@/paraglide/runtime";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

export const Route = createFileRoute("/$lang/auth/email")({
	validateSearch: zodValidator(
		z.object({
			code: z.any().optional(),
			email: z.string().optional(),
			redirect_params: z.string().optional(),
		}),
	),
	loaderDeps: ({ search }) => search,
	loader: async ({ deps: { code, email, redirect_params } }) => {
		if (code && email) {
			const rt = await commonLogin("email", { code: String(code), email });
			console.log(rt);
			if (rt.code === 0 && rt.data.token) {
				localStorage.setItem("AUTH_TOKEN", rt.data.token);
				authChannel.postMessage({
					type: AUTH_EVENT_TYPE.LOGIN,
				});
				return redirect({
					to: redirect_params || localizeHref("/"),
					replace: true,
				});
			}
		}
	},
	component: RouteComponent,
	errorComponent: ({ error }) => {
		return <Message text={error.message} />;
	},
});

function RouteComponent() {
	return <Message text="Loading..." />;
}

function Message({ text }: { text: string }) {
	return (
		<div className="h-full flex items-center justify-center">
			<div className="text-lg font-bold text-t2">{text}</div>
		</div>
	);
}
